// 引入工具函数
import req from '@/utils/request'
import axios from 'axios'

// let severUrl;
// // 环境的切换
// if (process.env.NODE_ENV == 'development') {
//     severUrl = 'http://47.107.129.103:8085';
//     // severUrl = 'http://10.193.86.148:8085';

// } else if (process.env.NODE_ENV == 'debug') {

// } else if (process.env.NODE_ENV == 'production') {
//     severUrl = '/api';
// }
//图片上传地址
// export const IP=severUrl
// export const IP='http://139.9.244.152:8085'
// export const IP='http://10.193.86.148:8801'
// export const IP = 'https://5726735cp6.oicp.vip';
export const IP = '';


//登录
export const login = (params) => {
    return req.post('/login', params);
}
//验证码
export const codes = () => {
    return req.get('/verification/code');
}
//导航栏
export const infoNav = (params) => {
    return req.get('/menu/info', params);
}
// 酒吧列表
export const webBarPage = (params) => {
    return req.get('/web/bar/webBarPage', params)
}

// 酒吧上下架
export const baronOff = (params) => {
    return req.put('/web/bar/onOff', params)
}

// 酒吧审核列表
export const webBarExaminePage = (params) => {
    return req.get('/web/bar/webBarExaminePage', params)
}

// 管理端酒吧详情
export const webBarDetail = (params) => {
    return req.get('/web/bar/webBarDetail', params)
}

// 酒吧审核
export const webBarExamine = (params) => {
    return req.get('/web/bar/webBarExamine', params)
}

// 活动列表
export const allActivity = (params) => {
    return req.get('/web/bar/allActivity', params)
}

// 获取活动详情
export const activityDetail = (params) => {
    return req.get('/web/bar/activityDetail', params)
}
// // 添加活动
export const webAddActivity = (params) => {
    return req.post('/web/bar/addActivity', params)
}
// 修改活动
export const updateActivity = (params) => {
    return req.put('/web/bar/updateActivity', params)
}

// 删除活动
export const delActivity = (params) => {
    return req.get('/vx/barLogin/delActivity', params)
}

// 评论分页
export const webCommentPage = (params) => {
    return req.get('/web/comment/webCommentPage', params)
}

// 管理端评论详情
export const webCommentDetail = (params) => {
    return req.get('/web/comment/webCommentDetail', params)
}

// 评论审核
export const webCommentExamine = (params) => {
    return req.get('/web/comment/webCommentExamine', params)
}

// 用户列表
export const webUserPage = (params) => {
    return req.get('/web/user/webUserPage', params)
}

// 设置会员
export const setVip = (params) => {
    return req.get('/web/user/setVip', params)
}

// 取消会员
export const cancelVip = (params) => {
    return req.get('/web/user/cancelVip', params)
}

// 会员列表
export const webVipUserPage = (params) => {
    return req.get('/web/user/webVipUserPage', params)
}

// 轮播图列表
export const bannerPage = (params) => {
    return req.get('banner/bannerPage', params)
}

// 轮播图删除
export const delBanner = (params) => {
    return req.get('/banner/delBanner', params)
}

// 设置轮播图顺序
export const setSort = (params) => {
    return req.get('/banner/setSort', params)
}

// 轮播图详情
export const bannerDetail = (params) => {
    return req.get('/banner/bannerDetail', params)
}

// 添加轮播图
export const addBanner = (params) => {
    return req.post('/banner/addBanner', params)
}

// 修改轮播图
export const updateBanner = (params) => {
    return req.put('/banner/updateBanner', params)
}


// 意见反馈分页
export const findComplaintAll = (params) => {
    return req.get('/vx/complaint/findComplaintAll', params)
}

// 标签分页
export const labelPage = (params) => {
    return req.get('/web/label/labelPage', params)
}

// 删除标签
export const delLabel = (params) => {
    return req.get('/web/label/delLabel', params)
}

// 添加标签
export const addLabel = (params) => {
    return req.post('/web/label/addLabel', params)
}

// 获取系统参数
export const sysList = (params) => {
    return req.get('/web/label/sysList', params)
}

// 修改系统参数
export const updateSys = (params) => {
    return req.post('/web/label/updateSys', params)
}


// 角色管理新增角色
export const addRole = (params) => {
    return req.get('/webAdmin/addRole', params)
}
// 角色管理列表
export const rolePageList = (params) => {
    return req.get('/webAdmin/rolePageList', params)
}

// 角色管理删除
export const delRole = (params) => {
    return req.get('/webAdmin/delRole', params)
}
// 角色管理编辑
export const updateRole = (params) => {
    return req.post('/webAdmin/updateRole', params)
}
// 角色管理权限列表
export const grantList = (params) => {
    return req.get('/webAdmin/grantList', params)
}
// 角色管理根据id获取权限列表
export const grantListByRoleId = (params) => {
    return req.get('/webAdmin/grantListByRoleId', params)
}
// 角色管理分配权限
export const assignPer = (params) => {
    return req.post('/webAdmin/assignPer', params)
}

// 账号管理添加账号
export const addAcc = (params) => {
    return req.post('/webAdmin/add', params)
}
// 角色列表不分页
export const roleList = (params) => {
    return req.get('/webAdmin/roleList', params)
}
// 账号管理列表
export const accList = (params) => {
    return req.get('/webAdmin/list', params)
}
// 账号管理列表删除
export const accDel = (params) => {
    return req.get('/webAdmin/del', params)
}
// 账号管理列表编辑
export const update = (params) => {
    return req.post('/webAdmin/update', params)
}
// 账号管理修改密码
export const updatePwd = (params) => {
    return req.post('/webAdmin/updatePwd', params)
}
// 标签列表
export const labelList = (params) => {
    return req.get('/web/label/labelList', params)
}
// 添加酒吧
export const addActivity = (params) => {
    return req.post('/vx/bar/addActivity', params)
}
// 删除酒吧
export const delBar = (params) => {
    return req.get('/web/bar/delBar', params)
}
// 编辑酒吧
export const updateBar = (params) => {
    return req.put('/web/bar/updateBar', params)
}
// 轮播图上下架
export const onOff = (params) => {
    return req.put('/banner/onOff', params)
}
// 管理端查询收货地址
export const webGetReceivingAddress = (params) => {
    return req.get('/vx/logistics/webGetReceivingAddress', params)
}
// 发货
export const deliverGoods = (params) => {
    return req.put('/vx/logistics/deliverGoods', params)
}
// 快递公司列表
export const expressList = (params) => {
    return req.get('/vx/logistics/expressList', params)
}
// 平台活动列表
export const PlatformActivityList = (params) => {
    return req.get('/web/PlatformActivity/list', params)
}
// 平台活动新增
export const PlatformActivityAdd = (params) => {
    return req.post('/web/PlatformActivity/PlatformActivityAdd', params)
}
// 导入酒吧icon
export const importBarIcon = (params) => {
    return req.post('/web/barIcon/importBarIcon', params)
}
// 分页查询酒吧的icon
export const listBarIcon = (params) => {
    return req.get('/web/barIcon/listBarIcon', params)
}
// 新增/编辑
export const saveOrUpd = (params) => {
    return req.post('/web/barIcon/saveOrUpd', params)
}
// 新增/编辑
export const batchImportBar = (params) => {
    return req.post('/web/bar/batchImportBar', params)
}
// 视频上传
export const uploadVideo = (params) => {
    return req.post('/banner/uploadVideo', params)
}
// 视频上传
export const listVideos = (params) => {
    return req.get('/banner/listVideos', params)
}
// 查询兑换列表
export const recordList = (params) => {
    return req.post('/web/userActivity/recordList', params)
}
// 新增公司活动
export const corporationAdd = (params) => {
    return req.post('/admin/beer/code/corporation/add', params)
}
// 公司活动列表
export const corporationPage = (params) => {
    return req.post('/admin/beer/code/corporation/select/page', params)
}
// 公司活动详情
export const corporationInfo = (params) => {
    return req.get('/admin/beer/code/corporation/select/info', params)
}
// 兑换码列表
export const codePage = (params) => {
    return req.post('/admin/beer/code/data/select/page', params)
}
// 查询订阅模板
export const template = (params) => {
    return req.get('/admin/beer/applet/messages/template', params)
}
// 查询订阅模板
export const userList = (params) => {
    return req.post('/admin/beer/applet/messages/select/user', params)
}
// 新增订阅活动
export const addMessages = (params) => {
    return req.post('/admin/beer/applet/messages/add', params)
}
// 订阅活动列表
export const pageMessages = (params) => {
    return req.post('/admin/beer/applet/messages/page', params)
}
// 发送订阅活动
export const sending = (params) => {
    return req.get('/admin/beer/applet/messages/sending', params)
}
// 修改模板
export const editTemplate = (params) => {
    return req.post('/admin/beer/applet/messages/update/template', params)
}
// 订阅活动详情
export const messagesInfo = (params) => {
    return req.get('/admin/beer/applet/messages/info', params)
}
// 推送列表
export const pushList = (params) => {
    return req.post('/admin/beer/applet/messages/info/user', params)
}
import local from '@/utils/local'
axios.interceptors.request.use(config => {
    let token = local.get("t_k") || ""
    if (token) {
        config.headers.token = token;
    }
    return config
})
//导入进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 简单配置  进度条

// NProgress.set(0.4)
NProgress.configure({easing: 'ease', speed: 500, showSpinner: false});
// 导出
export const functiondownload = (url, params,isLoading) => {
    if (isLoading == true) {
        NProgress.inc(0.4)
        NProgress.start();
    }
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            params: params,
            responseType: 'blob',
        }).then(response => {
            const blob = new Blob([response.data]);
            let fileName = '后台表格.xlsx';
            if ('download' in document.createElement('a')) { // 非IE下载
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);// 释放URL 对象
                document.body.removeChild(elink)
                NProgress.done();
            } else { // IE10+下载
                navigator.msSaveBlob(blob, fileName)
                NProgress.done();
            }
            resolve(response);
        }).catch((err) => {
            reject(err)
        })
    });
}